import { useDeviationAnalysisComponent } from 'ClientPortal/src/pages/Assets/AssetDetails/AssetDeviationAnalysis/AssetDeviationAnalysisComponent.data'
import { useDeviationAnalysis } from 'ClientPortal/src/pages/Assets/AssetDetails/useDeviationAnalysis'
import { useAssetPageLayout } from '../AssetPageLayout/AssetPageLayout.data'
import { getValuationStructuresWithIndex } from 'ClientPortal/src/pages/Assets/AssetDetails/AssetDetails.utils'

export const useAssetDeviationAnalysis = () => {
    const { latestFinalizedValuationOrDraft } = useAssetPageLayout({ withoutHistorical: true })

    const {
        asset,
        assetId,
        isValuationsPending,
        isAssetPending,
        assetTitle,
        valuationOptions,
        groupedOptionsByLabel,
        isEnergySummaryEnabled,
        showDeviationAnalysis,
        hasGroupedValuations,
        assetEnergySummary,
        isAssetEnergySummaryLoading,
    } = useDeviationAnalysisComponent()

    const {
        deviationAnalysis,
        isDeviationAnalysisPending,
        baseValuation,
        comparisonValuation,
        setComparisonValuationId,
        setBaseValuationId,
    } = useDeviationAnalysis({
        selectedValuation: latestFinalizedValuationOrDraft,
        valuationOptions,
    })

    return {
        deviationAnalysis,
        isDeviationAnalysisPending,
        baseValuation,
        comparisonValuation,
        setComparisonValuationId,
        setBaseValuationId,
        groupedOptionsByLabel,
        allStructures: getValuationStructuresWithIndex(asset, latestFinalizedValuationOrDraft),
        assetId,
        assetTitle,
        assetEnergySummary,
        valuationOptions,
        isValuationsPending,
        isAssetEnergySummaryLoading,
        isAssetPending,
        isEnergySummaryEnabled,
        showDeviationAnalysis,
        hasGroupedValuations,
    }
}
